import { render, staticRenderFns } from "./FlippingCard.vue?vue&type=template&id=0a12adf6&scoped=true&"
import script from "./FlippingCard.vue?vue&type=script&lang=js&"
export * from "./FlippingCard.vue?vue&type=script&lang=js&"
import style0 from "./FlippingCard.vue?vue&type=style&index=0&id=0a12adf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a12adf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/travis/build/georgesoteriou/flip/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VCard,VCardActions,VCardTitle,VFlex,VSpacer})
